import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AIResponseSave, PlatformSource, RecentAnswer } from "winslow-core";
import { selectUser } from "../../redux/features/appData";
import { apiGetWorkspaceAnswers } from "../../services/AIService";
import { getDateDaysAgo } from "winslow-core";
import "./CollectionStats.css";
// import { apiGetCollectionQuestionCountForUserInWorkspace } from "../../services/CollectionService";
import { CollectionStatsQuestions } from "./CollectionStatsQuestions";
import { CategoriesChart } from "./CategoriesChart";
import {
  apiDashboardGetCategoryResponsesForCollection,
  apiDashboardGetThemeResponsesForCollection,
} from "../../services/DashboardService";
import { DashboardThemeResponse } from "winslow-core";
import { SummaryChart } from "./SummaryChart";
import RatingStats from "./RatingStats";
import EscalationStats from "./EscalationStats";
import { NameSelector } from "../NameSelector/NameSelector";
import { CategorySelector } from "./CategorySelector";

// import { CollectionResourcesZero } from "../collections/CollectionResourcesZero";
import { AnswerSidebar } from "../collections/HomeScreen/AnswerSidebar";
import { ViewToggle } from "./ViewToggle";
import { SourceSelector } from "../SourceSelector";
import { AskedQuestionsZero } from "../collections/AskedQuestionsZero";

const TAB_NUMBERS = {
  DASHBOARD: "1",
  CATEGORIES: "2",
  THEMES: "3",
  RATINGS: "4",
  ESCALATIONS: "5",
};

export const CollectionStats = () => {
  const { collectionId } = useParams();

  const storeUser = useSelector(selectUser);
  // const collections = useSelector(selectCollections);

  const [tabNumber, setTabNumber] = useState(TAB_NUMBERS.DASHBOARD);

  // const [collectionQuestionCount, setCollectionQuestionCount] = useState<
  //   CollectionQuestionCount[] | null
  // >(null);
  // const [userCount, setUserCount] = useState<number | null>(null);

  const [categoryResponses, setCategoryResponses] = useState<
    AIResponseSave[] | null
  >(null);
  const [themeResponses, setThemeResponses] = useState<
    DashboardThemeResponse[] | null
  >(null);
  const [nameFilter, setNameFilter] = useState<string | undefined>(undefined);
  const [sourceFilter, setSourceFilter] = useState<PlatformSource | undefined>(
    undefined
  );
  const [categoryFilter, setCategoryFilter] = useState<string | undefined>(
    undefined
  );
  // ratings-specific state moved to RatingsTab

  const [answers, setAnswers] = useState<RecentAnswer[] | null>(null);
  // const [ratingAnswers, setRatingAnswers] = useState<RecentAnswer[] | null>(null);

  const [view, setView] = useState<"cards" | "list" | "list">("cards");

  useEffect(() => {
    const loadData = async () => {
      if (storeUser && collectionId && storeUser.currentWorkspaceId) {
        const answersResult = await apiGetWorkspaceAnswers(
          storeUser.currentWorkspaceId,
          storeUser.id
        );
        if (answersResult) {
          setAnswers(answersResult);
        }
        // const cqc = await apiGetCollectionQuestionCountForUserInWorkspace(
        //   storeUser.currentWorkspaceId,
        //   storeUser.id
        // );
        // setCollectionQuestionCount(cqc);

        // category questions
        const payload = {
          greaterThan: getDateDaysAgo(30),
          lessThan: new Date(),
        };

        const catQuestions =
          await apiDashboardGetCategoryResponsesForCollection(
            collectionId,
            payload
          );

        if (catQuestions) {
          setCategoryResponses(catQuestions);
        }
      }
    };

    if (collectionId) {
      loadData();
    }
  }, [collectionId, storeUser]);

  const handleRefresh = async () => {
    if (storeUser && collectionId && storeUser.currentWorkspaceId) {
      const answersResult = await apiGetWorkspaceAnswers(
        storeUser.currentWorkspaceId,
        storeUser.id
      );
      if (answersResult) {
        setAnswers(answersResult);
      }

      // category questions
      const payload = {
        greaterThan: getDateDaysAgo(30),
        lessThan: new Date(),
      };

      const catQuestions =
        await apiDashboardGetCategoryResponsesForCollection(
          collectionId,
          payload
        );

      if (catQuestions) {
        setCategoryResponses(catQuestions);
      }
    }
  };

  // const countUniqueEmailUsers = (responses: RecentAnswer[]) => {
  //   const users: Map<string, boolean> = new Map<string, boolean>();
  //   responses.forEach((response: RecentAnswer) => {
  //     if (response.email) {
  //       users.set(response.email, true);
  //     }
  //   });
  //   return Array.from(users.keys()).length;
  // };

  const lazyLoadThemeResponses = async () => {
    if (!themeResponses && collectionId && categoryResponses) {
      const aiResponseSaveIds = categoryResponses.map(
        (response: AIResponseSave) => {
          return response.id;
        }
      );

      const themeQuestions = await apiDashboardGetThemeResponsesForCollection({
        questionIds: aiResponseSaveIds,
      });

      if (themeQuestions) {
        setThemeResponses(themeQuestions);
      }
    }
  };

  // const getCollectionQuestionCount = (collectionId: string) => {
  //   if (!collectionQuestionCount) {
  //     return 0;
  //   }

  //   const index = collectionQuestionCount.findIndex(
  //     (cqc: CollectionQuestionCount) => {
  //       return cqc.collectionId === collectionId;
  //     }
  //   );

  //   if (index === -1) {
  //     return 0;
  //   }

  //   return collectionQuestionCount[index].count;
  // };

  // let resources = 0;
  // if (collections && collectionId) {
  //   const index = collections.findIndex((collection) => collection.id === collectionId);
  //   if (index !== -1) {
  //     resources = collections[index].linkRecords.length;
  //   }
  // }

  const changeTab = (_: any, newValue: string) => {
    setTabNumber(newValue);

    if (newValue === TAB_NUMBERS.THEMES) {
      lazyLoadThemeResponses();
    }
  };

  const handleTabClick = (newTab: string) => {
    changeTab({}, newTab);
  };

  // const getThemeQuestions = (theme?: string) => {
  //   const responses: AIResponseSave[] = [];

  //   if (themeResponses) {
  //     themeResponses.forEach((themeResponse: DashboardThemeResponse) => {
  //       if (!theme || themeResponse.theme === theme) {
  //         responses.push(...themeResponse.aiResponses);
  //       }
  //     });
  //   }

  //   console.log("[getThemeQuestions] responses: ", responses);
  //   return responses;
  // };

  return (
    <div id="collection-stats">
      <div className="page-title">
        {/* {editingCollection ? "Edit" : "Create"} Collection */}
        Analytics
      </div>
      <div className="collection-stats-wrapper">
        <div className="collection-stats-tabs">
          <div 
            className={tabNumber === TAB_NUMBERS.DASHBOARD ? 
              "collection-stats-tab-selected" : "collection-stats-tab"
            }
            onClick={() => handleTabClick(TAB_NUMBERS.DASHBOARD)}
          >
            <span>Questions</span>
          </div>
          <div 
            className={tabNumber === TAB_NUMBERS.CATEGORIES ? 
              "collection-stats-tab-selected" : "collection-stats-tab"
            }
            onClick={() => handleTabClick(TAB_NUMBERS.CATEGORIES)}
          >
            <span>Categories</span>
          </div>
          <div 
            className={tabNumber === TAB_NUMBERS.RATINGS ? 
              "collection-stats-tab-selected" : "collection-stats-tab"
            }
            onClick={() => handleTabClick(TAB_NUMBERS.RATINGS)}
          >
            <span>Ratings</span>
          </div>
          <div 
            className={tabNumber === TAB_NUMBERS.ESCALATIONS ? 
              "collection-stats-tab-selected" : "collection-stats-tab"
            }
            onClick={() => handleTabClick(TAB_NUMBERS.ESCALATIONS)}
          >
            <span>Escalations</span>
          </div>
        </div>

        {tabNumber === TAB_NUMBERS.DASHBOARD && (
          <div className="collection-stats-tab-content">
            {answers && (
              <div className="collection-stats-summary-chart">
                <SummaryChart
                  responses={answers}
                  endDate={new Date()}
                  startDate={getDateDaysAgo(30)}
                  period={"daily"}
                />
              </div>
            )}

            {answers && answers.length > 0 && (
              <div className="collection-stats-filter">
                <NameSelector responses={answers} onChange={setNameFilter} />
                <SourceSelector
                  responses={answers}
                  onChange={setSourceFilter}
                />
                <ViewToggle view={view} setView={setView} />
              </div>
            )}

            {answers && answers.length > 0 && (
              <div className="collection-stats-feedback">
                <CollectionStatsQuestions
                  questions={answers}
                  filterName={nameFilter}
                  filterSource={sourceFilter}
                  view={view}
                />
              </div>
            )}

            {answers && answers.length === 0 && <AskedQuestionsZero variant="questions" />}
          </div>
        )}

        {tabNumber === TAB_NUMBERS.CATEGORIES && (
          <div className="collection-stats-tab-content">
            {categoryResponses && (
              <div className="collection-stats-categories-chart">
                <CategoriesChart
                  responses={categoryResponses}
                  endDate={new Date()}
                  startDate={getDateDaysAgo(30)}
                  period={"daily"}
                />
              </div>
            )}

            {answers && categoryResponses && categoryResponses.length > 0 && (
              <div className="collection-stats-filter">
                <CategorySelector
                  responses={categoryResponses}
                  onChange={setCategoryFilter}
                />
                <SourceSelector
                  responses={answers}
                  onChange={setSourceFilter}
                />
                <ViewToggle view={view} setView={setView} />
              </div>
            )}

            {answers && categoryResponses && categoryResponses.length > 0 && (
              <div className="collection-stats-feedback">
                <CollectionStatsQuestions
                  questions={answers}
                  filterName={nameFilter}
                  filterCategory={categoryFilter}
                  filterSource={sourceFilter}
                  view={view}
                />
              </div>
            )}

            {categoryResponses && categoryResponses.length === 0 && (
              <AskedQuestionsZero variant="categories" />
            )}
          </div>
        )}

        {tabNumber === TAB_NUMBERS.RATINGS && (
          <div className="collection-stats-tab-content">
            {answers ? (
              <RatingStats
                answers={answers.filter((a) => a.message?.feedbackRating)}
                onRatingDelete={handleRefresh}
              />
            ) : (
              <AskedQuestionsZero variant="ratings" />
            )}
          </div>
        )}

        {tabNumber === TAB_NUMBERS.ESCALATIONS && (
          <div className="collection-stats-tab-content">
            {answers ? (
              <EscalationStats
                answers={answers}
                onRefresh={handleRefresh}
              />
            ) : (
              <AskedQuestionsZero variant="escalations" />
            )}
          </div>
        )}
      </div>
      <AnswerSidebar />
    </div>
  );
};
